module.exports = __webpack_public_path__ + "static/media/importICloud3.b7a33b89.png";